import { useSelector } from 'react-redux';
import isMedicoExterno from '../util/medicoHelpers';

const useIsMedicoExterno = () => {
  const medico = useSelector(state => state.doctor.profile);
  return isMedicoExterno(medico);
};

export default useIsMedicoExterno;
